import { createRouter, createWebHashHistory } from "vue-router";
import { store } from "@/store";
import Layout from "@/layout";

const routes = [
  {
    //登录
    path: "/login",
    name: "Login",
    component: () => import("@/views/login.vue")
  },
  {
    //基本信息
    path: "/accountCenter",
    name: "AccountCenter",
    component: () => import("@/views/common/header/accountCenter.vue")
  },
  {
    //平台介绍
    path: "/platformIntroduction",
    name: "PlatformIntroduction",
    component: () => import("@/views/common/platformIntroduction/index.vue")
  },
  {
    //我的企业
    path: "/myTeam",
    name: "MyTeam",
    component: () => import("@/views/common/header/myTeam.vue")
  },
  {
    //权益信息
    path: "/interestsInfo",
    name: "InterestsInfo",
    component: () => import("@/views/common/interestsInfo/index.vue")
  },
  {
    //下载页
    path: "/download",
    name: "Download",
    meta: {
      title: "管管安全"
    },
    component: () => import("@/views/download/index.vue")
  },
  {
    //首页
    path: "/homePage",
    name: "HomePage",
    component: () => import("@/views/homePage/index.vue")
  },
  {
    //消息中心
    path: "/information",
    name: "Information",
    component: () => import("@/views/information/index.vue")
  },
  {
    //学习中心
    path: "/learning",
    name: "Learning",
    component: () => import("@/views/learning/index.vue")
  },
  {
    //公开课堂详情
    path: "/learning/publicDetail",
    name: "learningPublicDetail",
    component: () => import("@/views/learning/src/public/detail.vue")
  },
  {
    //受邀课详情
    path: "/learning/inviteStudyDetail",
    name: "learningInviteStudyDetail",
    component: () => import("@/views/learning/src/inviteStudy/detail.vue")
  },
  {
    //完善受邀信息
    path: "/confirm",
    name: "confirm",
    component: () => import("@/views/learning/confirm.vue")
  },
  {
    //学习中心综合测试
    path: "/learning/comtest",
    name: "learningComtest",
    component: () => import("@/views/learning/src/inviteStudy/comtest.vue")
  },
  {
    //资讯详情页
    path: "/learning/newDetail",
    name: "NewDetail",
    component: () => import("@/views/learning/src/news/components/newDetail.vue")
  },
  {
    //小视频详情页
    path: "/learning/littleVideoDetail",
    name: "LittleVideoDetail",
    component: () => import("@/views/learning/src/littleVideo/components/littleVideoDetail.vue")
  },
  {
    path: "/report",
    name: "Report",
    component: () => import("@/views/report/index.vue")
  },
  {
    path: "/report/detail",
    name: "ReportDetail",
    component: () => import("@/views/report/detail.vue")
  },
  {
    path: "/report/listDetail",
    name: "ReportList",
    component: () => import("@/views/report/listDetail.vue")
  },
  {
    //平台数据
    path: "/analysis",
    name: "Analysis",
    component: () => import("@/views/analysis/index.vue")
  },
  {
    //应用详情
    path: "/appletDetail",
    name: "AppletDetail",
    component: () => import("@/views/homePage/appCenters/appletDetail.vue")
  },
  {
    //套件详情
    path: "/myKitDetail",
    name: "MyKitDetail",
    component: () => import("@/views/homePage/myKit/myKitDetail.vue")
  },
  {
    //套件详情
    path: "/myKitEdit",
    name: "MyKitEdit",
    component: () => import("@/views/homePage/myKit/myKitEdit.vue")
  },
  {
    //我的应用设置
    path: "/myappedit",
    name: "MyAppEdit",
    component: () => import("@/views/homePage/myApp/myAppEdit.vue")
  },
  {
    //组织架构
    path: "/organization",
    name: "Organization",
    component: () => import("@/views/organization/index.vue")
  },
  {
    //企业管理
    path: "/manage",
    name: "Manage",
    component: () => import("@/views/manage/index.vue"),
    redirect: "/manage/company",
    children: [
      {
        path: "company",
        name: "CompanyInfo",
        component: () => import("@/views/manage/company-info/index.vue")
      },
      {
        path: "companyinfochange",
        name: "companyInfoChange",
        component: () => import("@/views/manage/company-info/company-info-change.vue")
      },
      {
        path: "certification",
        name: "Certification",
        component: () => import("@/views/manage/certification/index.vue")
      },
      {
        path: "officialLetter",
        name: "OfficialLetter",
        component: () => import("@/views/manage/certification/officialLetter.vue")
      },
      {
        path: "member",
        name: "Member",
        component: () => import("@/views/manage/member/index.vue"),
        meta: {
          isAdmin: true,
          __AUTH_ARG: "MEMBER_ALL"
        }
      },
      {
        path: "admin-list",
        name: "Admin",
        component: () => import("@/views/manage/setting-admin/index.vue"),
        meta: {
          isAdmin: true,
          __AUTH_ARG: "A010"
        }
      },
      {
        path: "set-admin",
        name: "SetAdmin",
        component: () => import("@/views/manage/setting-admin/set-admin.vue"),
        meta: {
          __AUTH_ARG: "A010"
        }
      },
      {
        path: "change-admin",
        name: "ChangeAdmin",
        component: () => import("@/views/manage/setting-admin/change-admin.vue"),
        meta: {
          isAdmin: true,
          __AUTH_ARG: "A010"
        }
      },
      {
        path: "setting-child",
        name: "Child",
        component: () => import("@/views/manage/setting-child/index.vue"),
        meta: {
          isAdmin: true,
          __AUTH_ARG: "A011"
        }
      },
      {
        path: "set-group",
        name: "SetChildGroup",
        component: () => import("@/views/manage/setting-child/group.vue"),
        meta: {
          isAdmin: true,
          __AUTH_ARG: "A011"
        }
      },
      {
        path: "permissions",
        name: "Permissions",
        component: () => import("@/views/manage/permissions/index.vue"),
        meta: {
          isAdmin: true,
          __AUTH_ARG: "A005"
        }
      },
      {
        //应用管理
        path: "appManagement",
        name: "AppManagement",
        component: () => import("@/views/manage/appManagement/index.vue"),
        meta: {
          isAdmin: true,
          __AUTH_ARG: "A006"
        }
      },
      {
        //临时账号
        path: "temporaryAccount",
        name: "TemporaryAccount",
        component: () => import("@/views/manage/temporaryAccount/index.vue")
      }
    ]
  },
  {
    path: "/createCompany",
    name: "CreateCompany",
    component: () => import("@/views/newCompany/createCompany.vue")
  },
  {
    path: "/joinCompany",
    name: "JoinCompany",
    component: () => import("@/views/newCompany/joinCompany.vue")
  },
  {
    path: "/agreement",
    name: "Agreement",
    component: () => import("@/views/login/agreement.vue")
  },
  {
    path: "/selectversion",
    name: "SelectVersion",
    component: () => import("@/views/login/selectVersion.vue")
  },
  {
    path: "/selectCompanyVersion",
    name: "SelectCompanyVersion",
    component: () => import("@/views/newCompany/selectCompanyVersion.vue")
  },
  {
    path: "/joinnewcompany",
    name: "JoinNewCompany",
    component: () => import("@/views/login/joinNewCompany.vue")
  },
  {
    path: "/",
    redirect: "/homePage"
  },
  //我的证书
  {
    path: "/myCertificate",
    name: "MyCertificate",
    component: () => import("@/views/myCertificate/index.vue")
  },
  //综合测试详情
  {
    path: "/comtestDetail",
    name: "ComtestDetail",
    component: () => import("@/views/learning/comtestDetail.vue")
  },
  //证书详情
  {
    path: "/certificateDetail",
    name: "CertificateDetail",
    component: () => import("@/views/myCertificate/certificateDetail.vue")
  },
  {
    path: "/myorder",
    component: Layout,
    redirect: "/myorder/index",
    alwaysShow: true, // will always show the root menu
    meta: { title: "平台端", icon: "el-icon-grape", affix: true },
    children: [
      {
        path: "index",
        name: "MyOrder",
        component: () => import("@/views/myorder/index.vue"),
        meta: { title: "我的订单", icon: "el-icon-grape" }
      },
      {
        path: "index/contract",
        name: "Contract",
        hidden: true,
        component: () => import("@/views/myorder/contract.vue"),
        meta: { title: "查看合同", icon: "el-icon-grape" }
      },
      {
        path: "details",
        name: "MyOrderDetails",
        hidden: true,
        component: () => import("@/views/myorder/details.vue"),
        meta: { title: "订单详情", activeMenu: "/myorder/index" }
      },
      {
        path: "details/info",
        name: "MyOrderInfo",
        hidden: true,
        component: () => import("@/views/myorder/details-info.vue"),
        meta: { title: "订单详情", activeMenu: "/myorder/index" }
      }
    ]
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  if (to.path.includes("/learning")) {
    store.commit("auth/addCachedPages", "Learning");
  } else {
    store.commit("auth/removeCachedPages", "Learning");
  }

  if (to.name === "Download") {
    next();
  }
  if (to.name === "Agreement") {
    next();
    return;
  }
  if (to.name === "SelectVersion") {
    next();
    return;
  }
  if (to.name === "JoinNewCompany") {
    next();
    return;
  }
  if (to.name !== "Login" && !(store.state.auth.token && store.state.auth.userData && store.state.auth.companyData)) {
    store.commit("auth/clear");
    next("/login");
  } else {
    if (to.name === "Login" && store.state.auth.token && store.state.auth.userData && store.state.auth.companyData) {
      next(from.path !== "/" && from.path !== "/login" ? from.path : "/homePage");
    } else if (to.name === "Login" && to.query.token) {
      store.commit("auth/setToken", to.query.token);
      store.dispatch("auth/getUserInfo");
      store.dispatch("auth/getCompanyList");
    } else next();
  }
});
export default router;
